export default "__VITE_ASSET__8ebe8352__"